import React from 'react';
import moment from 'moment-timezone';

export function DisplayTimezone({ timezone }) {
  return <>{moment().tz(timezone).format('z')}</>;
}